import { useMemo } from 'react'
import { GraphQL } from '@guestgoodie/graphql'
import { Trans } from '@lingui/react/macro'
import { Alert01Icon, AlertCircleIcon } from '@hugeicons/core-solid-rounded'
import { Link } from 'wouter'

import Button from '@/components/ui/Button'
import useOrganization from '../hooks/useOrganization'
import { HugeiconsIcon } from '@hugeicons/react'

const timeFormatter = Intl.DateTimeFormat()

export function StateBanner() {
  const { organization } = useOrganization()

  const state = organization.state

  const endGraceAt = useMemo(
    () =>
      organization.endGraceAt
        ? timeFormatter.format(new Date(organization.endGraceAt))
        : null,
    [organization]
  )

  const endTrialAt = useMemo(
    () =>
      organization.endTrialAt
        ? timeFormatter.format(new Date(organization.endTrialAt))
        : null,
    [organization]
  )

  const permanentDeleteAt = useMemo(
    () =>
      organization.permanentDeleteAt
        ? timeFormatter.format(new Date(organization.permanentDeleteAt))
        : null,
    [organization]
  )

  if (state === GraphQL.OrganizationState.Active) return null
  if (!endGraceAt && !endTrialAt && !permanentDeleteAt) return null

  if (organization.deleted) {
    return (
      <div className="flex flex-row items-center p-2">
        <HugeiconsIcon icon={Alert01Icon} className="text-red-500" />
        <span className="text-red-500">
          <Trans>
            This hotel was deleted! It will be deleted on: {permanentDeleteAt}.
          </Trans>
        </span>
      </div>
    )
  }

  return (
    <Link asChild to="/organization-billing">
      <Button Icon={AlertCircleIcon}>
        {state === GraphQL.OrganizationState.Trial && endTrialAt && (
          <span>
            <Trans>Your trial ends on {endTrialAt}.</Trans>
          </span>
        )}
        {state === GraphQL.OrganizationState.Grace && endGraceAt && (
          <span>
            <Trans>
              Your organization will be set inactive on {endGraceAt}.
            </Trans>
          </span>
        )}{' '}
        <Trans>Click to activate</Trans>
      </Button>
    </Link>
  )
}
